import { ReactNode } from 'react';

interface MobileStatProps {
  icon: string;
  label: ReactNode;
  value: ReactNode;
  valueClassName?: string;
}

/**
 * Single stat entry inside a mobile card's stats grid: icon on the left,
 * label above value on the right. Matches the shared
 * `.mobile-stat-item` markup used across the DashboardV2 mobile cards.
 */
export function MobileStat({ icon, label, value, valueClassName }: MobileStatProps) {
  return (
    <div className="mobile-stat-item">
      <div className="mobile-stat-icon">
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <div>
        <p className="mobile-stat-label">{label}</p>
        <p className={valueClassName ? `mobile-stat-value ${valueClassName}` : 'mobile-stat-value'}>
          {value}
        </p>
      </div>
    </div>
  );
}

interface MobileCardActionsProps {
  editLabel: ReactNode;
  deleteLabel: ReactNode;
  onEdit: () => void;
  onDelete: () => void;
  deleteDisabled?: boolean;
}

/**
 * Right-aligned edit/delete action row shown at the bottom of a mobile card.
 */
export function MobileCardActions({
  editLabel,
  deleteLabel,
  onEdit,
  onDelete,
  deleteDisabled,
}: MobileCardActionsProps) {
  return (
    <div
      style={{
        display: 'flex',
        gap: '0.5rem',
        marginTop: '0.75rem',
        justifyContent: 'flex-end',
      }}
    >
      <button type="button" className="secondary-action-btn" onClick={onEdit}>
        <span className="material-symbols-outlined">edit</span>
        {editLabel}
      </button>
      <button
        type="button"
        className="secondary-action-btn"
        onClick={onDelete}
        disabled={deleteDisabled}
      >
        <span className="material-symbols-outlined">delete</span>
        {deleteLabel}
      </button>
    </div>
  );
}
